<a class="logo__wrapper" routerLink="/">
  <div class="logo__layout">
    <app-logo
      class="logo__image"
      [mode]="mode === 'mobile' || !isOpen ? 'logo' : 'header-logo'"
      [width]="size * 3"
      [height]="size"
    ></app-logo>
  </div>
</a>
